/* A1 theme — global UI: announcement rotator, header, mega menu, mobile drawer, testimonials */
(function () {
  'use strict';

  /* Announcement bar rotation */
  function initAnnouncement() {
    var bar = document.querySelector('[data-announcement]');
    if (!bar) return;
    var messages = Array.prototype.slice.call(bar.querySelectorAll('.announcement-bar__message'));
    if (messages.length < 2) return;
    var interval = parseInt(bar.getAttribute('data-interval') || '5', 10) * 1000;
    var index = 0;
    setInterval(function () {
      messages[index].classList.remove('is-active');
      index = (index + 1) % messages.length;
      messages[index].classList.add('is-active');
    }, interval);
  }

  /* Header shadow on scroll */
  function initHeaderScroll() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Mega menu: hover intent (150ms), close grace, keyboard + Escape */
  function initMegaMenu() {
    var items = document.querySelectorAll('.nav__item.has-mega');
    if (!items.length) return;
    var openTimer = null;
    var closeTimer = null;

    function open(item) {
      clearTimeout(closeTimer);
      closeTimer = null;
      items.forEach(function (other) {
        if (other !== item) close(other);
      });
      item.classList.add('is-open');
      var link = item.querySelector('.nav__link');
      if (link) link.setAttribute('aria-expanded', 'true');
    }

    function close(item) {
      item.classList.remove('is-open');
      var link = item.querySelector('.nav__link');
      if (link) link.setAttribute('aria-expanded', 'false');
    }

    function closeAll() {
      items.forEach(close);
    }

    items.forEach(function (item) {
      var link = item.querySelector('.nav__link');

      item.addEventListener('mouseenter', function () {
        if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        openTimer = setTimeout(function () { open(item); }, 150);
      });

      item.addEventListener('mouseleave', function () {
        if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () { close(item); }, 300);
      });

      if (link) {
        link.addEventListener('focus', function () { open(item); });
        link.addEventListener('click', function (e) {
          /* Touch / coarse pointers: tap toggles the panel instead of navigating */
          if (window.matchMedia('(hover: none)').matches && item.querySelector('.mega-panel')) {
            if (!item.classList.contains('is-open')) {
              e.preventDefault();
              open(item);
            }
          }
        });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });

    document.addEventListener('focusin', function (e) {
      items.forEach(function (item) {
        if (!item.contains(e.target)) close(item);
      });
    });
  }

  /* Mobile drawer */
  function initMobileDrawer() {
    var openBtns = document.querySelectorAll('[data-mobile-open]');
    var drawer = document.querySelector('[data-mobile-drawer]');
    var scrim = document.querySelector('[data-drawer-scrim]');
    if (!drawer) return;
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      if (scrim) scrim.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      drawer.setAttribute('aria-hidden', 'false');
      var closeBtn = drawer.querySelector('[data-mobile-close]');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      drawer.classList.remove('is-open');
      if (scrim) scrim.classList.remove('is-open');
      document.body.style.overflow = '';
      drawer.setAttribute('aria-hidden', 'true');
      if (lastFocus) lastFocus.focus();
    }

    openBtns.forEach(function (btn) { btn.addEventListener('click', open); });
    drawer.querySelectorAll('[data-mobile-close]').forEach(function (btn) { btn.addEventListener('click', close); });
    if (scrim) scrim.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  /* Testimonial slider */
  function initTestimonials() {
    document.querySelectorAll('[data-testimonials]').forEach(function (slider) {
      var track = slider.querySelector('[data-testimonial-track]');
      var slides = slider.querySelectorAll('.testimonial');
      var dotsWrap = slider.querySelector('[data-testimonial-dots]');
      if (!track || slides.length < 2) return;
      var index = 0;

      slides.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'testimonial__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', slider.getAttribute('data-slide-label') + ' ' + (i + 1));
        dot.addEventListener('click', function () { go(i); });
        dotsWrap.appendChild(dot);
      });
      var dots = dotsWrap.querySelectorAll('.testimonial__dot');

      function go(i) {
        index = (i + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + index * 100 + '%)';
        dots.forEach(function (d, di) { d.classList.toggle('is-active', di === index); });
      }

      slider.querySelector('[data-testimonial-prev]').addEventListener('click', function () { go(index - 1); });
      slider.querySelector('[data-testimonial-next]').addEventListener('click', function () { go(index + 1); });

      var timer = setInterval(function () { go(index + 1); }, 7000);
      slider.addEventListener('mouseenter', function () { clearInterval(timer); });
    });
  }

  /* Mobile search toggle */
  function initMobileSearch() {
    var header = document.querySelector('[data-header]');
    var toggles = document.querySelectorAll('[data-search-toggle]');
    if (!header || !toggles.length) return;
    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = header.classList.toggle('search-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          var input = header.querySelector('[data-predictive-input]');
          if (input) input.focus();
        }
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && header.classList.contains('search-open')) {
        header.classList.remove('search-open');
        toggles.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      }
    });
    document.addEventListener('click', function (e) {
      if (!header.classList.contains('search-open')) return;
      var searchBox = header.querySelector('.header__search');
      if (searchBox && searchBox.contains(e.target)) return;
      if (e.target.closest && e.target.closest('[data-search-toggle]')) return;
      header.classList.remove('search-open');
      toggles.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    });
  }

  /* Shared helpers for the other theme scripts */
  var A1 = window.A1 = window.A1 || {};
  A1.money = function (cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    var locale = document.documentElement.lang || undefined;
    try {
      return (cents / 100).toLocaleString(locale, { style: 'currency', currency: currency });
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  };
  A1.root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* Recently viewed: product pages record their handle (product.js); this renders the section anywhere */
  var RV_KEY = 'a1_recently_viewed';
  A1.recentlyViewed = {
    read: function () {
      try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) { return []; }
    },
    add: function (handle) {
      if (!handle) return;
      var list = A1.recentlyViewed.read().filter(function (h) { return h !== handle; });
      list.unshift(handle);
      try { localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 12))); } catch (e) { /* private mode */ }
    }
  };

  function initRecentlyViewed() {
    document.querySelectorAll('[data-recently-viewed]').forEach(function (box) {
      var grid = box.querySelector('[data-recently-viewed-grid]');
      var current = box.getAttribute('data-current');
      var limit = parseInt(box.getAttribute('data-limit') || '4', 10);
      var sectionId = box.getAttribute('data-card-section');
      var handles = A1.recentlyViewed.read().filter(function (h) { return h && h !== current; }).slice(0, limit);
      if (!grid || !handles.length || !window.fetch) return;
      Promise.all(handles.map(function (handle) {
        return fetch(A1.root + 'products/' + encodeURIComponent(handle) + '?section_id=' + sectionId)
          .then(function (r) { return r.ok ? r.text() : ''; })
          .catch(function () { return ''; });
      })).then(function (htmls) {
        var cards = htmls.map(function (html) {
          if (!html) return '';
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var card = doc.querySelector('[data-product-card]');
          return card ? card.outerHTML : '';
        }).filter(Boolean);
        if (!cards.length) return;
        grid.innerHTML = cards.join('');
        box.hidden = false;
        document.dispatchEvent(new CustomEvent('a1:cards-added', { detail: { container: grid } }));
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initRecentlyViewed();
    initAnnouncement();
    initHeaderScroll();
    initMegaMenu();
    initMobileDrawer();
    initMobileSearch();
    initTestimonials();
  });
})();
